import { FeatureStates } from './v2/client-state/features';

// declare webpack define plugin variables before use
declare let __API_ENDPOINT_URL__: string;
declare let __API_ENDPOINT_URL_V2__: string;
declare let __STORAGE_KEY_PREFIX__: string;
declare let __ENV__: string;
declare let __BUILDDATE__: string;

type Constants = Readonly<{ [key: string]: string | number }>;

export const constants: Constants = {
  API_ENDPOINT_URL: __API_ENDPOINT_URL__,
  API_ENDPOINT_URL_V2: __API_ENDPOINT_URL_V2__,
  STORAGE_KEY_PREFIX: __STORAGE_KEY_PREFIX__,
  BUILDDATE: __BUILDDATE__,
  ENV: __ENV__,
  EVENTSTORE_DEFAULT_MAX_EVENT_COUNT: 200,
  CLIENT_EVENTS_MAX_COUNT: 2000,
  DEFAULT_TIMEOUT: 5000, // in miliseconds
};

export const DEFAULT_FEATURE_STATES: FeatureStates = {
  INDEXEDDB_EVENTS: false,
  IFRAME_NATIVES: true,
};
